import React from 'react'

export default class Boilerplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
    }
  }
  componentDidMount() {
    console.log('componentDidMount', this.state.value);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    console.log('getDerivedStateFromProps', nextProps, prevState);
    if (nextProps.value!==prevState.value) {
      return {
        value: nextProps.value,
        updated: Date.now(),
      }
    }
    return null
  }
  render() {
    return (
      <div>
        <h1>Boilerplate</h1>
        <div>{this.state.value}</div>
        <div>{this.state.updated}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Test.js